<template>
	<div class="login-page">
		<div class="login-container">

			<h2 class="login-title">用户登录</h2>

			<el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="90px" class="login-form">
				<el-form-item label="登陆账号:" prop="username">
					<el-input v-model="loginForm.username" placeholder="请输入手机号" maxlength="64" clearable></el-input>
				</el-form-item>
				<el-form-item label="登陆密码:" prop="password">
					<el-input v-model="loginForm.password" type="password" placeholder="请输入密码" show-password></el-input>
				</el-form-item>

				<el-form-item label="验证码" prop="code">
					<el-row :gutter="5">
						<el-col :span="16">
							<el-input v-model="loginForm.code" placeholder="请输入验证码" maxlength="6"></el-input>
						</el-col>
						<el-col :span="7">
							<img :src="codeImg" class="code-img" @click="refreshCode" />
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>

			<div
				style="display: flex;flex-direction: row;justify-content: space-between; padding-left: 20px; padding-right: 20px;">
				<el-checkbox v-model="loginForm.remember">记住我</el-checkbox>
				<el-button type="text" @click="goToRegister">注册账号</el-button>
			</div>


			<el-button type="primary" class="login-btn" @click="handleLogin" :loading="loading">
				登录
			</el-button>


		</div>
	</div>
</template>

<script>
	import {
		getCodeImg,
		login
	} from '@/api/user'

	import {
		validatePhone
	} from '@/utils/validate'

	export default {
		name: 'Login',
		data() {
			return {
				loading: false,
				codeImg: null, // 验证码图片
				loginForm: {
					username: 'o3VCi6fF8BQpUQMykNGgWXFZ6yXA',
					password: '123456',
					code: '',
					remember: false
				},
				loginRules: {
					username: [{
						required: true,
						message: '请输入登陆账号',
						trigger: 'blur'
					}],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							message: '密码长度不能少于6位',
							trigger: 'blur'
						}
					],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}]
				}
			}
		},




		mounted() {
			this.refreshCode()
		},


		methods: {


			// 刷新验证码
			async refreshCode() {
				const temp = await getCodeImg()
				if (temp.code == 200) {
					this.codeImg = 'data:image/png;base64,' + temp.data.img
				}
			},



			// 跳转到注册页
			goToRegister() {
				this.$router.push('/register')
			},



			// Login.vue中handleLogin方法修改
			handleLogin() {
				this.$refs.loginForm.validate(async (valid) => {
					if (valid) {
						this.loading = true
						try {
							const loginData = {
								'tenantId': '102657',
								'clientId': '428a8310cd442757ae699df5d894f051',
								'grantType': 'password',
								'username': this.loginForm.username,
								'password': this.loginForm.password, // 补充密码
								'code': this.loginForm.code // 补充验证码
							}

							// 登录请求（返回的token会被Vuex处理为access_token）
							await this.$store.dispatch('user/login', loginData)

							// 获取用户信息
							await this.$store.dispatch('user/getInfo')

							this.$message.success('登录成功！')

							// 跳转到之前的页面或首页
							const redirect = this.$route.query.redirect || '/'
							this.$router.push(redirect)
						} catch (error) {
							this.$message.error('登录失败，请检查账号密码！')
							this.refreshCode() // 刷新验证码
						} finally {
							this.loading = false
						}
					}
				})
			}



		}
	}
</script>

<style lang="scss" scoped>
	.login-page {
		min-height: 70vh;
		background-color: #f5f5f5;
		display: flex;
		align-items: center;
		justify-content: center;

		.login-container {
			text-align: center;
			padding: 20px;
			background-color: #fff;
			border-radius: 8px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

			.login-title {
				margin-top: 10px;
				text-align: center;
				margin-bottom: 20px;
				color: #009933;
			}

			.login-form {
				width: 400px;

				.code-img {
					margin-top: 3px;
					width: 100%;
					height: 35px;
					cursor: pointer;
				}
			}


			.login-btn {
				margin: 20px;
				width: 200px;
			}
		}
	}
</style>